export const NotificationTypeEnum = [
    { id: 'banner', name: 'Banner' },
    { id: 'popup', name: 'Popup' }
];